import { message } from "antd";
import { axios, handleError } from "../../lib";

export const altUsers = (data) => ({
  type: "ALT_USERS",
  data,
});

export const searchUsers = async (qrCode) => {
  return await axios.get(`/admin/users/user-details-qr-search/${qrCode}`);
};

export const checkInUsers = (data) => async (dispatch) => {
  try {
    const { responseCode, ...response } = await axios.post(
      `/admin/users/check-in-user`,
      data
    );
    await dispatch(getAllUsers("", true));
    if (response.status === "success") {
      message.success(response.details, 8);
    } else {
      message.error(response.details, 8);
    }
  } catch ({ response }) {
    handleError(response);
  }
};

export const getAllUsers =
  (queries = "", force = false) =>
  async (dispatch, getState) => {
    try {
      // Check if we already have users and it's not a forced refresh or filtered search
      if (!force && !queries) {
        const { users } = getState().dashStats;
        if (users && users.data && users.data.length > 0) {
          return;
        }
      }

      let url = `/admin/users/all`;

      if (queries) {
        url += queries.startsWith("?") ? queries : `?${queries}`;
      }

      const { responseCode, ...response } = await axios.get(url);

      if (response && response.data) {
        dispatch(altUsers(response));
      }
    } catch ({ response }) {
      handleError(response);
    }
  };

export const debitUserAccount = async (payload) => {
  try {
    const { responseCode, ...response } = await axios.post(
      `/admin/users/debit-wallet`,
      payload
    );
    return response;
  } catch ({ response }) {
    handleError(response);
  }
};

export const getUser = async (id) => {
  try {
    const { responseCode, ...response } = await axios.get(
      `/admin/users/user-details/${id}`
    );
    return response;
  } catch ({ response }) {
    handleError(response);
  }
};

export const getUserVisits = async (id, query = "") => {
  try {
    const { responseCode, ...response } = await axios.get(
      `/admin/users/check-ins/${id}${query}`
    );
    return response;
  } catch ({ response }) {
    handleError(response);
  }
};

export const banUsers = (id, name) => async (dispatch) => {
  try {
    const response = await axios.post(`/admin/users/ban/${id}`, { name });

    if (response.status === "success") {
      await dispatch(getAllUsers(response.data, true));
      message.success(response.details, 8);
      return {
        success: true,
      };
    }
  } catch ({ response }) {
    handleError(response);
  }
};

export const altSubscriptionStatus = (id, status) => async (dispatch) => {
  try {
    const response = await axios.post(
      status === "active"
        ? `/admin/subscription/${id}/pause`
        : `/admin/subscription/${id}/resume`
    );

    if (response.status === "success") {
      await dispatch(getAllUsers(response.data, true));
      message.success(response.details, 8);
      return {
        success: true,
      };
    }
  } catch ({ response }) {
    handleError(response);
  }
};

export const cancelSubscription = (id) => async (dispatch) => {
  try {
    const response = await axios.post(`/admin/subscription/${id}/cancel`);

    if (response.status === "success") {
      await dispatch(getAllUsers("", true));
      message.success(response.details, 8);
      return {
        success: true,
      };
    } else {
      message.error(response.details || "Failed to cancel subscription", 8);
      return {
        success: false,
      };
    }
  } catch ({ response }) {
    handleError(response);
    return {
      success: false,
    };
  }
};

export const unbanUsers = (id, name) => async (dispatch, getState) => {
  try {
    const response = await axios.post(`/admin/users/un-ban/${id}`, { name });
    if (response.status === "success") {
      await dispatch(getAllUsers(response.data, true));
      message.success(response.details, 8);
      return {
        success: true,
      };
    }
  } catch ({ response }) {
    handleError(response);
  }
};

export const updateUser = (id, data) => async (dispatch) => {
  try {
    let payload = data;
    if (!(data instanceof FormData)) {
      payload = new FormData();
      Object.keys(data).forEach((key) => {
        if (data[key] !== undefined && data[key] !== null) {
          if (key === "image") {
            if (data[key] instanceof File) {
              payload.append("image", data[key]);
            }
          } else {
            payload.append(key, data[key]);
          }
        }
      });
    }

    const response = await axios.post(`/admin/users/update/${id}`, payload);
    if (response.status === "success") {
      message.success(response.details || "Successfully updated user details", 8);
      return {
        success: true,
        data: response.data,
      };
    } else {
      message.error(response.details || "Failed to update user", 8);
      return {
        success: false,
      };
    }
  } catch ({ response }) {
    handleError(response);
    return {
      success: false,
    };
  }
};

